<!--予約情報をタイムラインに表示するボックス-->
<template lang="html">
  <div class="reservationBox" :style="getStyle"
  :class="{
    firstTime: canDisplay && reservation.reservation_type === '初回',
    trial: canDisplay && reservation.reservation_type === '体験',
    hasTest: canDisplay && reservation.hasTest,
    hasMessage: canDisplay && reservation.message !== '',
    grayedOut: !canDisplay
  }"
  @mousemove="mousemoveHandler($event)"
  @mouseup="mouseupHandler($event)"
  @mouseout="hover = false"
  @click="clickHandler"
  >
    <statelist v-if="canDisplay" :reservation="reservation"></statelist>
    <div>
      {{ reduceTimeExp(reservation.start_time) }}〜
    </div>
    <div>
      {{ reduceTimeExp(reservation.end_time) }}
    </div>
    <div v-if="canDisplay">
      <div>
        {{ reservation.student.fullname }} 様
        <span v-if="isVailedCheck" @click.stop="toggleAttendance(reservation.student.id)">
          {{ attendingState(reservation.student.id) }}
        </span>
      </div>
      <div>
        {{ reservation.teacher.fullname }} 先生
        <span v-if="isVailedCheck" @click.stop="toggleAttendance(reservation.teacher.id)">
          {{ attendingState(reservation.teacher.id) }}
        </span>
      </div>
    </div>
    <p v-else>予約済み</p>
    <!-- <button
    v-if="hover && !isEditing && isEditable"
    class="editButton"
    @click="enterEdit()">編集</button> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  PREVIEWBOX_HIDE_POPUP,
  PREVIEWBOX_TIME_UPDATE,
  SHOW_INFORMATION_POPUP,
  HIDE_INFORMATION_POPUP
} from '@/vuex/mutation_types'
import ReservationStates from './SpReservationStates'
import T from '@/modules/time'
export default {
  components: {
    'statelist': ReservationStates
  },
  props: [
    'reservation'
  ],
  data () {
    return {
      style: {},
      hover: false
    }
  },
  methods: {
    reduceTimeExp (timeStr) {
      return timeStr.slice(0, 5)
    },
    clickHandler (event) {
      if (this.canDisplay) {
        this.$store.commit(PREVIEWBOX_HIDE_POPUP)// 予約のポップアップを非表示にする
        this.$store.commit(PREVIEWBOX_TIME_UPDATE, {// プレビューボックス（ドラッグで伸縮可能な箱)の時刻を変更する
          start: '10:00',
          end: '10:00'
        })
        this.$store.commit(HIDE_INFORMATION_POPUP)
        this.$store.commit(SHOW_INFORMATION_POPUP, this.reservation)
      }
    },
    mousemoveHandler (event) {
      this.hover = true
      this.$emit('pvmousemove', {
        e: {
          offsetY: event.layerY + this.timeToPosition(this.reservation.start_time)
        },
        classroom: this.reservation.classroom
      })
    },
    mouseupHandler (event) {
      this.$emit('pvmouseup', {
        e: {
          offsetY: event.layerY + this.timeToPosition(this.reservation.start_time)
        },
        classroom: this.reservation.classroom
      })
    },
    enterEdit () {
      this.$store.commit('RESERVATIONBOX_ENTER_EDIT', this.reservation)
      this.$store.commit('EDITINGBOX_STYLE_UPDATE', this.getStyle)
    },
    toggleAttendance (userId) {
      this.$store.dispatch('toggleAttendance', userId).then(() => {
        this.$store.dispatch('getAttendance')
      })
    },
    isAttending (id) {
      return this.$store.state.attendance.includes(id)
    },
    attendingState (id) {
      return this.isAttending(id) ? '☑' : '□'
    }
  },
  computed: {
    ...mapGetters([
      'getLeftPosOfClassroom',
      'timeToPosition'
    ]),
    getStyle () {
      const width = this.$store.state.columnWidth * this.$store.state.mobileWidthMagnification
      const top = this.timeToPosition(
        new T(this.reservation.start_time).toString()
      ) * this.$store.state.mobileHeightMagnification
      const bottom = this.timeToPosition(
        new T(this.reservation.end_time).toString()
      ) * this.$store.state.mobileHeightMagnification
      const height = bottom - top
      const left = this.getLeftPosOfClassroom(
        this.reservation.classroom
      ) * this.$store.state.mobileWidthMagnification
      let opacity = 1.0
      if (this.isEditing && this.reservation.id === this.$store.state.editingState.id) {
        opacity = 0.5
      }
      return {
        width: width + 'px',
        height: height + 'px',
        top: top + 'px',
        left: left + 'px',
        opacity: opacity
      }
    },
    isEditing () {
      return this.$store.state.editingState.id !== 0
    },
    isEditable () {
      let userType = this.$store.state.userInfo.user_type
      return userType !== 'student' &&
              (userType === 'admin' ||
              this.reservation.teacher.id === this.$store.state.userInfo.user_id
            ) &&
            this.isFuture &&
            this.isBeforeDeadline
    },
    isFuture () {
      // 現在時刻が予約時刻よりも前かどうか
      let today = new Date()
      let date = this.reservation.date.split(' ')[0].split('-').map((x) => parseInt(x))
      let startTime = this.reservation.start_time.split(' ')[0].split(':').map((x) => parseInt(x))
      let reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1])
      return today.getTime() < reservationDate.getTime()
    },
    isBeforeDeadline () {
      // 現在時刻が予約時刻の1日前(予約時刻が月曜日の場合は2日前)の22時以前かどうか
      let today = new Date()
      let date = this.reservation.date.split(' ')[0].split('-').map((x) => parseInt(x))
      let startTime = this.reservation.start_time.split(' ')[0].split(':').map((x) => parseInt(x))
      let reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1])

      let dateDiff = (new Date(reservationDate.getFullYear(), reservationDate.getMonth(), reservationDate.getDate()) -
                        new Date(today.getFullYear(), today.getMonth(), today.getDate())) / 1000 / 60 / 60 / 24
      return (reservationDate.getDay() === 1 && (dateDiff > 2 || (dateDiff === 2 && today.getHours() < 22))) ||   // 予約時刻が月曜日の場合
              (reservationDate.getDay() !== 1 && (dateDiff > 1 || (dateDiff === 1 && today.getHours() < 22)))     // 月曜日以外の場合
    },
    isVailedCheck () {
      let today = new Date()
      if (this.$store.state.userInfo.user_type === 'admin' &&
      this.$store.state.curDate.getMonth() === today.getMonth() &&
      this.$store.state.curDate.getDate() === today.getDate()) {
        return true
      } else {
        return false
      }
    },
    canDisplay () {
      let userType = this.$store.state.userInfo.user_type
      let userId = this.$store.state.userInfo.user_id
      return (userType === 'admin' || userType === 'viewer' ||
      (userType === 'teacher' && this.reservation.teacher.id === userId) ||
      (userType === 'student' && this.reservation.student.id === userId))
    }
  }
}
</script>

<style lang="css" scoped>
.reservationBox {
  box-sizing: border-box;
  font-size: 5vw;
  background-color: white;
  border-style: solid;
  border-color: #0065B3;
  position: absolute;
  z-index: 999;
  overflow: hidden;
}
.reservationBox:hover {
  overflow: visible;
}
.editButton {
  box-sizing: border-box;
  background-color: white;
  border-style: solid;
  border-color: none;
  display: inline;
}
.trial, .firstTime {
  background-color: #ddddff;
}
.grayedOut {
  border-color: #888888;
  color: #888888;
}
</style>



// WEBPACK FOOTER //
// SpReservationBox.vue?1fac333a